module.exports = __webpack_public_path__ + "media/images/emblems/Wengi_bei_Bueren-coat_of_arms-948b8b73912f7a00be09e85ef4d1909c.svg";